"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DoubleArrowLeftIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/DoubleArrowLeftIcon"));
const DoubleArrowRightIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/DoubleArrowRightIcon"));
const useSidebar_1 = require("../../hooks/useSidebar");
const MenuItem_1 = require("./MenuItem");
const Separator = styled_components_1.default.div `
  border-top: 1px solid ${({ theme }) => theme.ui01};
`;
/** Renders the collapse item */
const CollapseItem = ({ label, ...rest }) => {
    const { isSidebarCollapsed, setSidebarCollapsed } = (0, useSidebar_1.useSidebar)();
    const icon = isSidebarCollapsed ? (react_1.default.createElement(DoubleArrowRightIcon_1.default, null)) : (react_1.default.createElement(DoubleArrowLeftIcon_1.default, null));
    const onTrigger = () => setSidebarCollapsed(isCollapsed => !isCollapsed);
    return (react_1.default.createElement(Separator, { ...rest },
        react_1.default.createElement(MenuItem_1.MenuItem, { as: "div", label: label, icon: icon, onTrigger: onTrigger })));
};
exports.CollapseItem = CollapseItem;
